import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import constants from 'scoreboard/components/constants'

var SearchView = Backbone.View.extend({

	/** Used to cancel previous request if we submit a new one before it returns */
	xhr: undefined,

	/**
	 * Delay in ms after a user presses a key before the search is sent to the
	 * server
	 */
	searchDelay: constants.SEARCH_DELAY,

	/**
	 * The results from the last unfiltered search.
	 * Therefore, representing all possible results.
	 */
	allSearchResults: [],

	/**
	 * Common functionality for views that issue an XHR to request data from
	 * the server based on a user's input
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {String|Function} options.url the URL prefix to use for
	 */
	initialize(options = {}) {
		this.options = options
		this.url = _.result(this.options, 'url')
	},

	search: function(text, options) {
		this.createLoadingDots()

		clearTimeout(this.xhrTimeout)
		if (this.xhr && this.xhr.readyState != XMLHttpRequest.DONE) {
			this.xhr.abort()
		}
		this.xhrTimeout = setTimeout(function() {
			let conjunction = _.includes(this.url, '?') ? '&' : '?'
			const params = conjunction + $.param({text})
			this.xhr = $.get(this.url + params, (results, status, xhr) => {
				if (!text) this.allSearchResults = results
				this.draw(results, options, text, xhr)
				this.trigger('load', results) // For the cache (potentialPrincipals) in principal-panel.js
			})
		}.bind(this), this.searchDelay)
	},

	/**
	 * Draws the results of the search
	 *
	 * @param results the results returned from the server
	 * @param options any options passed to this.search
	 * @param text the text that was searched for
	 * @param xhr the XHR that retrieved the search results
	 */
	draw: function(results, options, text, xhr) {
		// subclasses need to implement this
	},

	createLoadingDots: function() {
		this.loadingTimeout = setTimeout(() => this.appendLoadingDots(),
			constants.LOADING_TIME)
	},

	appendLoadingDots: function() {
		if (!this.$('.loading-dots').length) {
			this.loadingDotsContainer().addClass('is-loading')
				.append(`<span class="select-item-after">${loadingDots()}</span>`)
		}
	},

	loadingDotsContainer: function() {
		return this.$('.select-control')
	},

	clearLoadingDots: function () {
		this.loadingDotsContainer().removeClass('is-loading')
		this.$('.loading-dots').remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		clearTimeout(this.xhrTimeout)
	}


})

export default SearchView

SearchView.__filename__ = 'components/search-view.js'
